import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";
import Index from "./index";
import Edit from "./edit";

export default class Base extends Component {
    render() {
        return (
                <Switch>
                    <Route exact path="/missions" component={Index}/>
                    <Route path="/missions/create" component={Edit}/>
                    <Route path="/missions/:id" component={Edit}/>
                </Switch>
        )
    }
}
